import { IconAlertTriangleFilled } from "@tabler/icons-react";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import { MantineIconCell } from "../../../../mantine/mrt/components/cell/MantineIconCell";
import type { Paragraph6ContractResponse } from "../../Paragraph6.types";

function getGeneratorsColumn(): MRT_ColumnDef<Paragraph6ContractResponse> {
  return {
    header: "Erzeuger",
    enableColumnFilter: false,
    accessorFn: (rowData) => rowData?.gemeinde_anteile_erzeuger?.length,
    Cell: ({ cell }) => {
      const generatorCount = cell.getValue<number | undefined>();
      if (generatorCount && generatorCount > 0) {
        return `${generatorCount} Erzeuger`;
      }
      return (
        <MantineIconCell
          iconColor="var(--mantine-color-warning-filled)"
          IconComponent={IconAlertTriangleFilled}
          renderedCellValue="Keine Erzeuger"
        />
      );
    }
  };
}

export { getGeneratorsColumn };
